import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Disclaimer } from "@/components/Disclaimer";

const cols = [
  { title: "Product", links: [["Markets", "/markets"], ["AI Signals", "/signals"], ["AI Analyst", "/ai-analyst"], ["Paper Trading", "/paper-trading"], ["Backtesting", "/backtesting"]] },
  { title: "Company", links: [["About", "/about"], ["Pricing", "/pricing"], ["Academy", "/academy"], ["Trust Center", "/trust-center"], ["FAQ", "/faq"]] },
  { title: "Legal", links: [["Risk Disclosure", "/risk-disclosure"], ["Terms", "/terms"], ["Privacy", "/privacy"], ["Cookie Policy", "/cookie-policy"], ["AI Disclaimer", "/ai-disclaimer"], ["Responsible Trading", "/responsible-trading"]] },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-card/50" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="space-y-4">
            <Logo />
            <p className="text-sm text-muted-foreground max-w-xs">AI-powered market intelligence, probabilistic signals, paper trading and risk management for disciplined traders.</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="mb-3 text-sm font-semibold">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-muted-foreground hover:text-foreground">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10"><Disclaimer /></div>
        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row">
          <span>© {new Date().getFullYear()} KREONIS. All market data shown is DEMO/simulated.</span>
          <span>Not investment advice. KREONIS does not custody funds.</span>
        </div>
      </div>
    </footer>
  );
}
